// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","482":"charts"}[chunkId] + "-legacy." + {"443":"8596a7d8","482":"36757d99"}[chunkId] + ".js";
};